import request from '@/utils/request'

const url = 'externalPush'

/** 获取推送规则列表 */
export function searchExternalPushList(data) {
  return request({
    url: `${url}/searchExternalPushList`,
    method: 'post',
    data
  })
}

/** 查看规则列表 */
export function getElevatorExternalPushInfo(data) {
  return request({
    url: `${url}/getElevatorExternalPushInfo`,
    method: 'post',
    data
  })
}

/** 删除规则列表 */
export function deleteElevatorExternalPushInfo(data) {
  return request({
    url: `${url}/deleteElevatorExternalPushInfo`,
    method: 'post',
    data
  })
}

/** 修改规则列表 */
export function editElevatorExternalPushInfo(data) {
  return request({
    url: `${url}/editElevatorExternalPushInfo`,
    method: 'post',
    data
  })
}

/** 添加规则列表 */
export function insertElevatorExternalPush(data) {
  return request({
    url: `${url}/insertElevatorExternalPush`,
    method: 'post',
    data
  })
}

/** 获取平台下拉框 */
export function getPlatformSelectList(data) {
  return request({
    url: `select/getPlatformSelectList`,
    method: 'post',
    data
  })
}
